import React, { useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { usePapaParse } from 'react-papaparse';
import S from './SensorDataTab.module.scss';
import { importCSVApiCall } from 'services/api';

const SensorImportTab = () => {
  const { readString } = usePapaParse();
  const inputRef = useRef(null);
  const [fileName, setFileName] = useState('');
  const [previewRows, setPreviewRows] = useState([]);
  const [error, setError] = useState('');
  const [isImporting, setIsImporting] = useState(false);
  const currentUserId = useSelector((state) => state.authentifie?.user_id);

  const handleFile = (file) => {
    if (!file || isImporting) return;
    setFileName(file.name);
    setError('');
    setPreviewRows([]);
    setIsImporting(true);

    const reader = new FileReader();
    reader.onload = (event) => {
      readString(String(event.target.result || ''), {
        header: true,
        delimiter: ';',
        skipEmptyLines: true,
        complete: async ({ data }) => {
          const rows = (data || []).filter(
            (row) => row && Object.keys(row).length
          );
          try {
            await importCSVApiCall({
              user_id: currentUserId,
              sensors_data: rows,
            });
            setPreviewRows(rows);
          } catch {
            setError("L'import CSV a échoué.");
          } finally {
            setIsImporting(false);
          }
        },
        error: () => {
          setError('Impossible de lire le CSV.');
          setIsImporting(false);
        },
      });
    };
    reader.onerror = () => {
      setError('Impossible de lire le fichier.');
      setIsImporting(false);
    };
    reader.readAsText(file, 'UTF-8');
  };

  return (
    <div className={S.importSection}>
      <div
        className={S.dropZone}
        onClick={() => {
          if (!isImporting) inputRef.current?.click();
        }}
      >
        <div className={S.dropIcon}>📂</div>
        <div className={S.dropLabel}>Importer un CSV</div>
        <p>Format attendu: sensor_id;pk_test;time_unix;value;calc_value</p>
        <input
          ref={inputRef}
          type="file"
          accept=".csv"
          className={S.fileInput}
          disabled={isImporting}
          onChange={(e) => handleFile(e.target.files?.[0])}
        />
      </div>

      {isImporting && (
        <div className={S.loadingState}>
          <div className={S.loadingCard}>
            <div className={S.loadingSpinner} />
            <p>Import CSV en cours...</p>
          </div>
        </div>
      )}

      {fileName && <div className={S.formatInfo}>{fileName}</div>}
      {error && <div className={S.alertErreur}>{error}</div>}
      {previewRows.length > 0 && (
        <div className={S.formatInfo}>
          {previewRows.length} ligne(s) parsée(s)
        </div>
      )}
    </div>
  );
};

export default SensorImportTab;
